module.exports = __webpack_public_path__ + "static/awareness_dashbord-456bd0e8082acf626bd6ed25c237b4bf.png";